import type { SharedValue } from "react-native-reanimated";
import { useAnimatedStyle } from "react-native-reanimated";
import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors }) => ({
  iconContainer: {
    width: spacing(7),
    height: spacing(7),
    alignItems: "center",
    justifyContent: "center",
  },
  iconLayer: {
    position: "absolute",
  },
  icon: {
    width: spacing(7),
    height: spacing(7),
    color: colors.foregroundDefault,
  },
}));

export const useVoiceSearchButtonAnimatedStyles = ({
  progress,
}: {
  progress: SharedValue<number>;
}) => {
  const micStyle = useAnimatedStyle(() => ({
    opacity: 1 - progress.value,
    transform: [{ scale: 0.85 + (1 - progress.value) * 0.15 }],
  }));

  const stopStyle = useAnimatedStyle(() => ({
    opacity: progress.value,
    transform: [{ scale: 0.85 + progress.value * 0.15 }],
  }));

  return { micStyle, stopStyle };
};

export default stylesheet;
